import component from './compareButton.component'
import './compareButton.scss'

let module = angular.module('compareButton', [])
	.component('compareButton', component)
	.name;

export default module;


// WEBPACK FOOTER //
// ./app/components/compareButton/compareButton.js